import { FeatureToggleService } from './FeatureToggleService'
import { featureToggleApi, mockFeatureToggleApi } from '../api/featureToggleApi'

const api = import.meta.env.MODE === 'development' ? mockFeatureToggleApi : featureToggleApi
export const featureToggleService = new FeatureToggleService(api)
